import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'src/routes/hooks';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import RiskMitigatioonSurveyTable from './survey-table';
const RiskMitigationView = () => {
    const searchParams = useSearchParams();
    const token = searchParams.get('token') || localStorage.getItem('authToken') || '';
    console.log('myToken', token)

    const { id } = useParams();
    const [RiskMitigatioonSurveyDetails, setRiskMitigatioonSurveyDetails] = useState();  // New state for incident details

    useEffect(() => {
        getRiskMitigatioonSurvey();
    }, [])

    const getRiskMitigatioonSurvey = async () => {
        const data = await getRequest(endpoints.risk_management.mitigation_survey.mitigation_survey_Show(id));
        console.log("🚀 ~ getRiskMitigatioonSurvey ~ data:", data)
        setRiskMitigatioonSurveyDetails(data);

    }
    return (
        <RiskMitigatioonSurveyTable data={RiskMitigatioonSurveyDetails} />
    );
};
export default RiskMitigationView;